var map = {
	"./ad.svg": "a778",
	"./address.svg": "0e25",
	"./admin.svg": "ced6",
	"./afterSale.svg": "3e9f",
	"./appVersion.svg": "b0ff",
	"./bank.svg": "8315",
	"./brand.svg": "4c66",
	"./category.svg": "f428",
	"./collector.svg": "0339",
	"./content.svg": "33c4",
	"./contract.svg": "eeeb",
	"./dashboard.svg": "f782",
	"./device.svg": "2c87",
	"./deviceFunction.svg": "8cee",
	"./equipmentManagement.svg": "6b2a",
	"./example.svg": "30c3",
	"./externalConfig.svg": "d670",
	"./eye.svg": "4df5",
	"./financial-payment.svg": "95d4",
	"./financial-refund.svg": "3d49",
	"./financial.svg": "fef9",
	"./form.svg": "eb1b",
	"./freight.svg": "0ed7",
	"./gradeSetting.svg": "7840",
	"./jys.svg": "f13a",
	"./link.svg": "18f0",
	"./loginCode.svg": "20ea",
	"./loginPw.svg": "a1d1",
	"./loginUser.svg": "50fc",
	"./mall.svg": "155f",
	"./member.svg": "daf4",
	"./nested.svg": "dcf8",
	"./newsCenter.svg": "dada",
	"./order.svg": "11ff",
	"./others.svg": "3756",
	"./password.svg": "2a3d",
	"./product.svg": "8d30",
	"./raffle.svg": "ac34",
	"./regionalAgent.svg": "64f8",
	"./share.svg": "5306",
	"./store.svg": "443b",
	"./store_change.svg": "6407",
	"./system.svg": "30a9",
	"./table.svg": "47f1",
	"./tag.svg": "f1fc",
	"./tree.svg": "93cd",
	"./tuiguangSetting.svg": "23ce",
	"./user.svg": "b3b5",
	"./userAccount.svg": "c78a",
	"./userCredit.svg": "aa771",
	"./users.svg": "5055",
	"./vip.svg": "1296"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";